import 'jquery';
import airlineField from './airlineField';

var airlineFields = {

  i18n : {

    /**
     * German translation.
     * @type {Object}
     */
    de : require('./i18n/de'),

    /**
     * English translation.
     * @type {Object}
     */
    en : require('./i18n/en'),

    /**
     * Spanish translation.
     * @type {Object}
     */
    es : require('./i18n/es'),

    /**
     * French translation.
     * @type {Object}
     */
    fr : require('./i18n/fr'),

    /**
     * Italian translation.
     * @type {Object}
     */
    it : require('./i18n/it'),

    /**
     * Swedish translation.
     * @type {Object}
     */
    sv : require('./i18n/sv')

  },

  /**
   * Init airline fields.
   */
  init: function() {

      airlineField.init();

      /**
       * German translation.
       */
      if($('.airline-field-de').length > 0) {
        $('.airline-field-de').each(function() {
          var $field = $(this);
          if(!$field.hasClass('hasAirlineSuggestions')) {
            $field.airlineField({ i18n: require('./i18n/de')});
          }
        });
      }

      /**
       * English airlineFields.
       */
      if($('.airline-field-en').length > 0) {
        $('.airline-field-en').each(function() {
          var $field = $(this);
          if(!$field.hasClass('hasAirlineSuggestions')) {
            $field.airlineField({ i18n: require('./i18n/en')});
          }
        });
      }

      /**
       * Spanish airlineFields.
       */
      if($('.airline-field-es').length > 0) {
        $('.airline-field-es').each(function() {
          var $field = $(this);
          if(!$field.hasClass('hasAirlineSuggestions')) {
            $field.airlineField({ i18n: require('./i18n/es')});
          }
        });
      }

      /**
       * French airlineFields.
       */
      if($('.airline-field-fr').length > 0) {
        $('.airline-field-fr').each(function() {
          var $field = $(this);
          if(!$field.hasClass('hasAirlineSuggestions')) {
            $field.airlineField({ i18n: require('./i18n/fr')});
          }
        });
      }

      /**
       * Italian airlineFields.
       */
      if($('.airline-field-it').length > 0) {
        $('.airline-field-it').each(function() {
          var $field = $(this);
          if(!$field.hasClass('hasAirlineSuggestions')) {
            $field.airlineField({ i18n: require('./i18n/it')});
          }
        });
      }

      /**
       * Swedish airlineFields.
       */
      if($('.airline-field-sv').length > 0) {
        $('.airline-field-sv').each(function() {
          var $field = $(this);
          if(!$field.hasClass('hasAirlineSuggestions')) {
            $field.airlineField({ i18n: require('./i18n/sv')});
          }
        });
      }
  }

};

module.exports = airlineFields;
